import _ from 'lodash';
import useGraphCategories from './useGraphCategories';
import { ISSUE_STATUSES } from '../../state/issue.statuses';
import { renderToString } from 'react-dom/server';
import Tooltip from './Tooltip/Tooltip';
import { mapColKeyToStyle } from './graph.palettes';
import { lightColorPalette } from '@linearb/linui-common';
import { CHART_LEGEND_ITEM_STYLE } from 'components/base/common-styles';
import { GRANULARITY_TYPES } from '../useProgressionOverTime/state.types';

const useGraph = ({ data, granularity, type, tooltipsData }) => {
  const categories = useGraphCategories({ data, granularity });
  let totalProgression = 0;

  const series = data.map((item, idx) => {
    const colKey = item?.key;
    const { name = '' } = ISSUE_STATUSES[colKey] || {};
    const colStyle = mapColKeyToStyle[colKey] || {};
    return {
      name,
      data: _.get(item, 'progression_data', []).map((point, colIdx) => {
        totalProgression += point.progression;
        return {
          y: point.progression,
          extraData: point
        };
      }),
      ...colStyle
    };
  });

  const graphOptions = {
    chart: {
      type: 'column',
      style: {
        fontFamily: 'Outfit'
      }
    },
    title: {
      text: ''
    },
    xAxis: {
      categories,
      ...(granularity.key === GRANULARITY_TYPES.WEEKLY.key && {
        title: {
          text: 'Week (end date)',
          margin: 10
        }
      })
    },
    yAxis: {
      title: ''
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      itemMarginTop: 10,
      itemMarginBottom: 10,
      itemStyle: CHART_LEGEND_ITEM_STYLE
    },
    plotOptions: {
      column: {
        stacking: 'value',
        borderColor: 'none'
      },
      series: {
        cursor: 'default',
        maxPointWidth: 50,
        stickyTracking: false,
        point: {
          events: {
            mouseOut() {
              this.series.chart.tooltip.hide();
            }
          }
        }
      }
    },
    series,
    tooltip: {
      useHTML: true,
      backgroundColor: '#FFF',
      stickOnContact: false,
      borderColor: lightColorPalette.lbBlue_20,
      outside: false,
      hideDelay: 0,
      shared: true,
      style: {
        zIndex: 200
      },
      formatter() {
        const colIdx = _.get(this, 'points[0].point.index');
        const tooltipData = tooltipsData[colIdx];

        return renderToString(
          <Tooltip
            data={tooltipData}
            granularity={granularity}
            type={type}
            withoutDelta={colIdx === 0}
          />
        );
      }
    }
  };

  return {
    graphOptions,
    isZeroProgression: totalProgression === 0
  };
};

export default useGraph;
